/**
 * `PUT /api/cart` builder — shipping-method change.
 *
 * Sibling of `updateCartQuantity` — same route, different write axis. Split
 * into two builders so each call site reads as the operation it actually
 * performs ("set shipping method") instead of "PUT cart with optional fields".
 *
 * @see packages/contract/src/cart-update.ts — request contract
 * @see app/api/cart/route.ts PUT — handler
 */

import type { CartUpdateShippingRequest } from "@kraahl/contract";

export interface UpdateCartShippingMethodArgs {
  id: string;
  shippingId: string;
  userId?: string | null;
  guestId?: string | null;
  signal?: AbortSignal;
}

export async function updateCartShippingMethod(
  args: UpdateCartShippingMethodArgs,
): Promise<void> {
  const body: CartUpdateShippingRequest = {
    id: args.id,
    shippingId: args.shippingId,
    ...(args.userId != null ? { userId: args.userId } : {}),
    ...(args.guestId != null ? { guestId: args.guestId } : {}),
  };

  const res = await fetch("/api/cart", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
    ...(args.signal ? { signal: args.signal } : {}),
  });

  if (!res.ok) {
    throw new Error(`HTTP ${res.status}`);
  }
}
